import { createStore } from 'redux';
import rootReducer from './modules/reducer';

const store = createStore(rootReducer);

export default store;
